export default "__VITE_ASSET__DYa_qTMN__"